module.exports = __webpack_public_path__ + "static/img/sw_banner_bg.0ec35c65.png";